import { Filter, UserPropertyFilter } from './types';

export const isUserPropertyFilter = (filter: Filter): filter is UserPropertyFilter => {
  return (filter as UserPropertyFilter).traitName !== undefined;
};
